import React from "react";
import { Outlet } from "react-router-dom";

export default function NafedHeadLayout() {
  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        margin: 0,
        padding: 0,
        background: "#f5f8fc",
        overflowX: "hidden",
      }}
    >
      <Outlet />
    </div>
  );
}